import React from "react";
import {
  siAcer, siAmd, siAsus, siBroadcom, siDell, siEpson, siHp, siIntel,
  siJira, siJunipernetworks, siKingstontechnology, siMotorola, siNutanix,
  siNvidia, siRedhat, siSamsung, siSeagate, siSupermicro, siSymantec, siVeeam,
} from "simple-icons";

// Partners we work with. `icon` is an official brand mark from the open-source
// Simple Icons set (bundled locally, no external calls). Brands not available
// in the library fall back to a clean text label so the grid stays consistent.
const PARTNERS = [
  { name: "Acer", icon: siAcer },
  { name: "AMD", icon: siAmd },
  { name: "Antec", icon: null },
  { name: "ASUS", icon: siAsus },
  { name: "Broadcom", icon: siBroadcom },
  { name: "Brocade", icon: null },
  { name: "Chenbro", icon: null },
  { name: "Dell", icon: siDell },
  { name: "Epson", icon: siEpson },
  { name: "Honeywell", icon: null },
  { name: "HP", icon: siHp },
  { name: "HPE", icon: null },
  { name: "Intel", icon: siIntel },
  { name: "Jira", icon: siJira },
  { name: "Juniper", icon: siJunipernetworks },
  { name: "Kensington", icon: null },
  { name: "Kingston", icon: siKingstontechnology },
  { name: "Mellanox", icon: null },
  { name: "Microsoft", icon: null },
  { name: "Motorola", icon: siMotorola },
  { name: "Nutanix", icon: siNutanix },
  { name: "NVIDIA", icon: siNvidia },
  { name: "PNY", icon: null },
  { name: "QLogic", icon: null },
  { name: "Red Hat", icon: siRedhat },
  { name: "Samsung", icon: siSamsung },
  { name: "SanDisk", icon: null },
  { name: "Seagate", icon: siSeagate },
  { name: "Supermicro", icon: siSupermicro },
  { name: "Symantec", icon: siSymantec },
  { name: "Tyan", icon: null },
  { name: "Veeam", icon: siVeeam },
  { name: "WD", icon: null },
];

const Partners = () => {
  return (
    <section className="py-24 bg-white">
      <div className="aaa-container">
        <div className="text-center max-w-2xl mx-auto mb-14">
          <p className="aaa-eyebrow mb-3">Our Friends</p>
          <h2 className="font-display text-3xl md:text-4xl font-bold">Partners</h2>
          <p className="mt-4 text-[#8a889c]">
            Trusted brands we source, configure and support for your business.
          </p>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-4">
          {PARTNERS.map((brand) => (
            <div
              key={brand.name}
              className="aaa-logo h-24 rounded-xl border border-gray-100 bg-[#fbfafc] flex items-center justify-center px-3 hover:border-[#e2a7c2] hover:shadow-md"
              style={brand.icon ? { "--brand": `#${brand.icon.hex}` } : {}}
              title={brand.name}
            >
              {brand.icon ? (
                <svg
                  role="img"
                  viewBox="0 0 24 24"
                  className="h-8 w-auto max-w-[70%]"
                  xmlns="http://www.w3.org/2000/svg"
                  aria-label={brand.name}
                >
                  <title>{brand.name}</title>
                  <path d={brand.icon.path} />
                </svg>
              ) : (
                <span className="aaa-logo-text font-display font-semibold text-[0.95rem]">
                  {brand.name}
                </span>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Partners;
